import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { Observable } from "rxjs";
import { MeterType } from "../models/meter.model";
import { ResponsePackage } from "shared-lib";

@Injectable({
    providedIn: 'root',
})
export class MeterService {
    private pathApi: string;
    constructor(private http: HttpClient, private config: AppConfig) {
        this.pathApi = this.config.setting['pathApi'] + 'meter/';
    }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    getAllMeterTypesForSelect(utilityId: number | null = null) {
        if(utilityId) {
            return this.http.get<ResponsePackage<MeterType[]>>(`${this.pathApi}getAllMeterTypesForSelect?utilityId=${utilityId}`,{headers: this.headers, observe: 'response'});
        }
        else {
            return this.http.get<ResponsePackage<MeterType[]>>(`${this.pathApi}getAllMeterTypesForSelect`,{headers: this.headers, observe: 'response'});
        }
    }

    getAllMeterTypes(dataIn: any): Observable<any> {
        return this.http.post(`${this.pathApi}getAllMeterTypes`, dataIn, { observe: 'response' });
    }

    deleteMeterType(id: number): Observable<any> {
        return this.http.delete(`${this.pathApi}deleteMeterType/${id}`, { observe: 'response' });
    }

    saveMeterType(meterType: MeterType): Observable<any> {
        const formData = new FormData();
        formData.append('id', meterType.id.toString());
        formData.append('name', meterType.name);
        formData.append('utilityId', meterType.utilityId.toString());
        if (meterType.imageUrl)
            formData.append('imageUrl', meterType.imageUrl);

        formData.append(
            'readingStepsSerialized',
            JSON.stringify(meterType.readingSteps)
        );

        formData.append(
            '',
            JSON.stringify(meterType.readingSteps)
        );
        meterType.meterSltStatuses.map((x) => x.id).forEach((id) => {
            formData.append('sltStatusIds', id.toString());
        });
        if (meterType.imageFile)
            formData.append('imageFile', meterType.imageFile);

        return this.http.post(`${this.pathApi}saveMeterType`, formData, { observe: 'response' });
    }

    getMeterTypesForOptions(): Observable<any> {
        return this.http.get(`${this.pathApi}getMeterTypesForOptions`, { observe: 'response' });
    }
}